export default (params) => ({
  trigger: {
    name: 'order_status_element.show_invite_to_pay_amount',
    params: params,
  },
  config: {
    schema: {
      total_amount: {
        type: 'number',
      },
    },
    event: {
      name: 'show_amount',
      params: {
        unit: 'euro',
        sub_feature: 'invite_to_pay',
        content: null,
      },
    },
    nonInt: true,
  },
});
